import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { rangeSliderInit } from "../lib/range-slider.js";
import { silenCalculator } from "../modules/silen/calculator.js";

onDocumentLoaded(() => {
    console.log("[smart-silen-page.js inited]");

    rangeSliderInit();
    silenCalculator();
});
